import { Text } from '@factorialco/deprecated-design-system'
import fileBlueImage from 'assets/images/file-blue.svg'
import fileImage from 'assets/images/file.svg'

import './index.styles.css'
const OFFICE_TYPES = ['DOC', 'XLS', 'PPT']

interface Props {
  mimetype: string
}

const typeRegex: Array<[RegExp, string]> = [
  [/zip/, 'zip'],
  [/pdf/, 'pdf'],
  [/image/, 'img'],
  [/mp4/, 'mp4'],
  [/mov/, 'mov'],
  [/video/, 'vid'],
  [/word|txt/, 'doc'],
  [/excel|csv|spreadsheetml/, 'xls'],
  [/presentation|powerpoint/, 'ppt'],
  [/text/, 'txt'],
]

function getType(mimetype: string): string {
  const name = typeRegex.find(([regexp]) => mimetype.match(regexp))

  return name ? name[1] : ''
}

export default function DocumentType(props: Props) {
  const { mimetype } = props

  const type = getType(mimetype).toUpperCase()

  const isOffice = OFFICE_TYPES.includes(type)

  return (
    <div className={'DocumentType_wrapper'}>
      <img src={isOffice ? fileBlueImage : fileImage} title={type} />
      <div className={'DocumentType_label'}>
        <Text color="grey000White" caps size="50" weight="bold" htmlTag="div">
          {type}
        </Text>
      </div>
    </div>
  )
}
